import api from '../../../services/api';
import { normalizeCompanyCostGroup, type CompanyCostGroup } from '../costGroups';

export { UNGROUPED_COST_GROUP, groupOptions, normalizeCompanyCostGroup } from '../costGroups';
export type { CompanyCostGroup } from '../costGroups';

// Grupy kosztów (MPK, migration 216): the owner's own split of fixed costs for
// the budget and the plan-vs-actual report. Backend: /api/company-cost-groups
// (same gate as the fixed costs). A group is archived, never deleted.

function normalizeList(data: unknown): CompanyCostGroup[] {
  return Array.isArray(data)
    ? data.map(normalizeCompanyCostGroup).filter((group): group is CompanyCostGroup => group !== null)
    : [];
}

export async function fetchCompanyCostGroups(): Promise<CompanyCostGroup[]> {
  return normalizeList((await api.get('/company-cost-groups')).data);
}

export async function createCompanyCostGroup(name: string): Promise<CompanyCostGroup> {
  return normalizeCompanyCostGroup((await api.post('/company-cost-groups', { name })).data) as CompanyCostGroup;
}

/** Rename, archive (`isActive: false`) or restore (`isActive: true`). */
export async function updateCompanyCostGroup(id: string, payload: { name?: string; isActive?: boolean }): Promise<CompanyCostGroup> {
  return normalizeCompanyCostGroup((await api.put(`/company-cost-groups/${encodeURIComponent(id)}`, payload)).data) as CompanyCostGroup;
}

/** The active groups in the new order; returns the whole list. */
export async function reorderCompanyCostGroups(ids: string[]): Promise<CompanyCostGroup[]> {
  return normalizeList((await api.put('/company-cost-groups/order', { ids })).data);
}
